(function () {
  if (window.__stepsVideoSectionInitialized) return;
  window.__stepsVideoSectionInitialized = true;

  const triggerSelector = '[data-step-video-trigger]';
  const contentSelector = '[data-step-video-modal-content]';

  function populateModal(trigger) {
    const modalSelector = trigger.getAttribute('data-step-video-modal');
    const templateId = trigger.getAttribute('data-step-video-template');

    if (!modalSelector || !templateId) return;

    const modal = document.querySelector(modalSelector);
    const template = document.getElementById(templateId);

    if (!modal || !template) return;

    const content = modal.querySelector(contentSelector);
    if (!content) return;

    content.innerHTML = '';
    content.appendChild(template.content.cloneNode(true));
  }

  function clearModalMedia() {
    document.querySelectorAll(contentSelector).forEach((content) => {
      content.innerHTML = '';
    });
  }

  document.addEventListener(
    'click',
    (event) => {
      const trigger = event.target.closest(triggerSelector);
      if (!trigger || trigger.disabled) return;
      populateModal(trigger);
    },
    true
  );

  document.body.addEventListener('modalClosed', () => {
    window.setTimeout(clearModalMedia, 0);
  });

  document.addEventListener('shopify:section:unload', () => {
    clearModalMedia();
  });
})();
